import React from 'react'
import Snap from '../assets/snap.png';
import Boat from '../assets/boat.png';
import buy from '../assets/buybook.png';
import tour from '../assets/touropia.png';
import sandesh from '../assets/sandesh.png';
import apple from '../assets/apple.png';
function Projects() {
  return (
    <div name='projects' className='w-full h-fit text-gray-300 bg-[#0a192f] '>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div className='pb-8 text-center'>
          <p className='text-6xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
            Projects
          </p>
          <p className='py-6 text-xl mt-2'> Check out some of my recent projects</p>
        </div>

        {/* Container */}
        <div className='grid  md:grid-cols-2 gap-4'>

          {/* Grid Item */}

          <div className="p-4 rounded-lg border-2 mb-5 border-pink-600">
          <div>
            {/* Hover Effects */}
            <p className='text-4xl text-gray-300 font-bold my-4 text-center'>Buy-book.com</p>
            <img src={buy} alt="snapdeal" className='rounded-md '/>
  
            
          </div>
  <div className='p-4'>
  <h2 className='text-2xl font-bold text-center my-2'>
  Description</h2>
  <p className='text-xl font-bold'>
  Buy book is the online book store from where you can order wide variety of book.I've used<span className='text-pink-600'> React, Redux-toolkit, Tailwind-css, Material-UI,Express in backend and MongoDb as database.</span> </p>
  </div>
          
          <div className='pt-4 text-center'>
            <a href='https://buy-bookm.netlify.app/' target="_blank"  rel="noreferrer">
            <button className='text-center rounded-lg px-4 py-3 m-2  border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
              Demo
            </button>
            </a>
            <a href='https://youtu.be/0zbP1-eka_o' target="_blank"  rel="noreferrer">
            <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
              Video
            </button>
          </a>

            <a href='https://github.com/vivekKumarSinghH/buy-book' target="_blank"  rel="noreferrer">
            <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
              Code
            </button>
          </a>
        </div>
        
        
        </div>
  
  


          {/* Grid Item */}
 {/* Grid Item */}

 <div className="p-4 rounded-lg border-2 mb-5 border-pink-600">
 <div>
   {/* Hover Effects */}
   <p className='text-4xl text-gray-300 font-bold my-4 text-center'>Touropia.com</p>
   <img src={tour} alt="snapdeal" className='rounded-md '/>

   
 </div>
<div className='p-4'>
<h2 className='text-2xl font-bold text-center my-2'>
Description</h2>
<p className='text-xl font-bold'>
TourOpia is the website to get information about famous tourist spots,here you can post about famous place and can see all the famous spots.I've used<span className='text-pink-600'> React, Redux-toolkit, mdb-react-ui-kit, Jwt, Express in backend and MongoDb as database.</span> </p>
</div>
 
 <div className='pt-4 text-center'>
   <a href='https://touropiac.netlify.app/' target="_blank"  rel="noreferrer">
   <button className='text-center rounded-lg px-4 py-3 m-2  border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
     Demo
   </button>
   </a>
   <a href='https://www.youtube.com/watch?v=uhfb-yOOClU' target="_blank"  rel="noreferrer">
   <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
     Video
   </button>
 </a>

   <a href='https://github.com/vivekKumarSinghH/Touropia' target="_blank"  rel="noreferrer">
   <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
     Code
   </button>
 </a>
</div>


</div>




          
          {/* Grid Item */}
 {/* Grid Item */}

 <div className="p-4 rounded-lg border-2 mb-5 border-pink-600">
 <div>
   {/* Hover Effects */}
   <p className='text-4xl text-gray-300 font-bold my-4 text-center'>Apple.com</p>
   <img src={apple} alt="snapdeal" className='rounded-md '/>

   
 </div>
<div className='p-4'>
<h2 className='text-2xl font-bold text-center my-2'>
Description</h2>
<p className='text-xl font-bold'>
Apple.com Apple Inc. is an American multinational technology company that specializes in consumer electronics, software and online services.I've used<span className='text-pink-600'> React, Tailwind-css.</span> </p>
</div>
 
 <div className='pt-4 text-center'>
   <a href='https://apple-clone-shersha.netlify.app/' target="_blank"  rel="noreferrer">
   <button className='text-center rounded-lg px-4 py-3 m-2  border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
     Demo
   </button>
   </a>
   

   <a href='https://github.com/vivekKumarSinghH/apple-react-clone' target="_blank"  rel="noreferrer">
   <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
     Code
   </button>
 </a>
</div>


</div>


<div className="p-4 rounded-lg border-2 mb-5 border-pink-600">
<div>
  {/* Hover Effects */}
  <p className='text-4xl text-gray-300 font-bold my-4 text-center'>Sandesh.com</p>
  <img src={sandesh} alt="snapdeal" className='rounded-md '/>

  
</div>
<div className='p-4'>
<h2 className='text-2xl font-bold text-center my-2'>
Description</h2>
<p className='text-xl font-bold'>
Sandesh is a real time one to one chat application, here you can send message to anyone who is online currently.I've used<span className='text-pink-600'> React, styled components, socket.io, Jwt, Express in backend and MongoDb as database.</span> </p>
</div>

<div className='pt-4 text-center'>
  <a href='https://sandesh-frontend.vercel.app/' target="_blank"  rel="noreferrer">
  <button className='text-center rounded-lg px-4 py-3 m-2  border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
    Demo
  </button>
  </a>
  <a href='
  https://user-images.githubusercontent.com/72158561/168902396-307fdc9b-4a27-4689-99bb-dcd57519b0b1.mp4' target="_blank"  rel="noreferrer">
  <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
    Video
  </button>
</a>

  <a href='https://github.com/vivekKumarSinghH/sandesh-chat-app' target="_blank"  rel="noreferrer">
  <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
    Code
  </button>
</a>
</div>


</div>






          {/* Grid Item */}
          <div className="p-4 rounded-lg border-2 mb-5 border-pink-600">
            <div>
              {/* Hover Effects */}
              <p className='text-4xl text-gray-300 font-bold my-4 text-center'>Boat.com</p>
              <img src={Boat} alt="boat" className='rounded-md  h-[230px]' />


            </div>
            <div className='p-4'>
              <h2 className='text-2xl font-bold text-center my-3'>
                Description</h2>
              <p className='text-xl font-bold mb-5'>
                This is the clone of Boat.com which is an ecommerce website where an user can order
                smart headphones.We have implemented this
                using <span className='text-pink-600'>HTML, CSS, Javascript and DOM.</span> </p>
            </div>

            <div className='pt-4 text-center'>
              <a href='https://zen-noether-1c54bb.netlify.app/' target="_blank" rel="noreferrer">
                <button className='text-center rounded-lg px-4 py-3 m-2  border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
                  Demo
                </button>
              </a>
              <a href='https://github.com/vivekKumarSinghH/boat-clone' target="_blank" rel="noreferrer">
                <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
                  Code
                </button>
              </a>
            </div>
          </div>

          <div className="p-4 rounded-lg border-2 mb-5 border-pink-600">
          <div>
            {/* Hover Effects */}
            <p className='text-4xl text-gray-300 font-bold my-4 text-center'>Snapdeal.com</p>
            <img src={Snap} alt="snapdeal" className='rounded-md '/>
  
            
          </div>
  <div className='p-4'>
  <h2 className='text-2xl font-bold text-center my-2'>
  Description</h2>
  <p className='text-xl font-bold'>
  This is the clone of snapdeal.com which is an ecommerce website where an user can order
  wide variety of lifestyle products.We have implemented this 
  using <span className='text-pink-600'>HTML, CSS, Javascript and Express in backend and MongoDb as database.</span> </p>
  </div>
          
          <div className='pt-4 text-center'>
            <a href='https://snapdeal-clone-zeta.vercel.app/index.html' target="_blank"  rel="noreferrer">
            <button className='text-center rounded-lg px-4 py-3 m-2  border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
              Demo
            </button>
            </a>
            <a href='https://github.com/vivekKumarSinghH/spandeal-clone' target="_blank"  rel="noreferrer">
            <button className='text-center rounded-lg px-4 py-3 m-2 border-2 font-bold text-xl hover:bg-pink-600 duration-300'>
              Code
            </button>
          </a>
        </div>
        
        
        </div>
  
  




        </div>
      </div>
    </div>
  )
}

export default Projects